import Vue, { CreateElement } from 'vue'
import Component from 'vue-class-component'
import { BurgerIcon } from '@src/components/burger-icon'

import './index.sass'
import { Icon } from '@src/elements/icon/icon'

@Component
export class PortraitHeader extends Vue {

  render (h: CreateElement) {
    return (
      <div class='portrait-header-root'>
        <div class='burger-wrapper'>
          <BurgerIcon />
        </div>
        <div class='header-icon'>
          <Icon name={'logo/logo-type'} />
        </div>
      </div>
    )
  }
}
